import { render, staticRenderFns } from "./RecoveryPasswordWaitEmail.vue?vue&type=template&id=4be7dc10&"
import script from "./RecoveryPasswordWaitEmail.vue?vue&type=script&lang=js&"
export * from "./RecoveryPasswordWaitEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports